<template>
  <div>
    <b-table
      borderless
      striped
      stacked="sm"
      :items="models"
      :fields="fields"
    >
      <template v-slot:cell(avatar)="data">
        <avatar :model="data" />
      </template>

      <template v-slot:cell(buttons)="data">
        <buttons :model="data" />
      </template>
    </b-table>
  </div>
</template>

<script>
import Avatar from './Avatar'
import Buttons from './Buttons/index'

export default {
  components: {
    Avatar,
    Buttons
  },

  data () {
    return {
      modelName: 'users',
      fields: [
        {
          key: 'avatar',
          label: '画像',
          tdClass: 'align-middle'
        },

        {
          key: 'last_name',
          label: '氏',
          tdClass: 'align-middle'
        },

        {
          key: 'first_name',
          label: '名',
          tdClass: 'align-middle'
        },

        {
          key: 'email',
          label: 'メール',
          tdClass: 'align-middle'
        },

        {
          key: 'buttons',
          label: 'アクション',
          tdClass: 'align-middle'
        }
      ]
    }
  },

  computed: {
    models () {
      return this.$store.state[this.modelName].models
    }
  }
}
</script>
